var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPaperPlane(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.178,
    d: "M6.79656991,14.1969771 L2.48094498,12.6850232 C2.48094498,12.6850232 1.49930491,12.1582393 2.3408817,11.5246586 C3.18245849,10.8922779 18.9353873,2.2753409 18.9353873,2.2753409 C18.9353873,2.2753409 20.1337065,1.43176665 19.9876576,2.69772801 C19.8823109,3.61210011 17.813684,16.7648987 17.813684,16.7648987 C17.813684,16.7648987 17.7777703,18.065659 16.7243029,17.6780709 C15.6732298,17.2916826 11.7789918,15.9213245 11.7789918,15.9213245 L9.21715067,20 C9.21715067,20 8.76104717,20 8.76104717,19.5776129 C8.76104717,19.1564257 8.72633063,15.2877438 8.72633063,15.2877438 C8.72633063,15.2877438 8.90111045,14.6541631 9.11180393,14.4081706 C9.32249741,14.1621782 17.0750597,5.7228357 17.0750597,5.7228357"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPaperPlane);
export default __webpack_public_path__ + "static/media/icon_paper_plane.95d7161f.svg";
export { ForwardRef as ReactComponent };